import { capitalize } from '../../../util/lodashlike';
export const NS_POST_CREATE_TICKET = 'NS_POST_CREATE_TICKET';
export const NS_POST_CREATE_TICKET_SUCCESS = 'NS_POST_CREATE_TICKET_SUCCESS';
export const NS_POST_CREATE_TICKET_FAIL = 'NS_POST_CREATE_TICKET_FAIL';
export const NS_GET_CURRENT_CHAMPION = 'NS_GET_CURRENT_CHAMPION';
export const NS_GET_CURRENT_CHAMPION_SUCCESS =
  'NS_GET_CURRENT_CHAMPION_SUCCESS';
export const NS_GET_CURRENT_CHAMPION_FAIL = 'NS_GET_CURRENT_CHAMPION_FAIL';
export const NS_GET_CHAMPION_CHALLENGER_DETAILS =
  'NS_GET_CHAMPION_CHALLENGER_DETAILS';
export const NS_GET_CHAMPION_CHALLENGER_DETAILS_SUCCESS =
  'NS_GET_CHAMPION_CHALLENGER_DETAILS_SUCCESS';
export const NS_GET_CHAMPION_CHALLENGER_DETAILS_FAIL =
  'NS_GET_CURRENT_CHAMPION_DETAILS_FAIL';

/**
 * Post Create Ticket
 **/
export const postCreateTicketForChampion = (payload) => {
  return {
    type: NS_POST_CREATE_TICKET,
    payload
  };
};

export const postCreateTicketForChampionSuccess = (payload) => {
  return {
    type: NS_POST_CREATE_TICKET_SUCCESS,
    payload
  };
};

export const postCreateTicketForChampionFail = (payload) => {
  return {
    type: NS_POST_CREATE_TICKET_FAIL,
    payload
  };
};

/**
 * Get Current Champion
 **/
export const getCurrentChampion = (payload) => {
  return {
    type: NS_GET_CURRENT_CHAMPION,
    payload
  };
};

export const getCurrentChampionSuccess = (payload) => {
  return {
    type: NS_GET_CURRENT_CHAMPION_SUCCESS,
    payload
  };
};

export const getCurrentChampionFail = (payload) => {
  return {
    type: NS_GET_CURRENT_CHAMPION_FAIL,
    payload
  };
};

/**
 * Get Champion and Challenger details
 **/
export const getChampionChallengerDetails = (payload) => {
  const { id, key } = payload;
  return {
    type: NS_GET_CHAMPION_CHALLENGER_DETAILS,
    payload: {
      id,
      key,
      loading: { [`is${capitalize(key)}Loading`]: true }
    }
  };
};

export const getChampionChallengerDetailsSuccess = (payload) => {
  return {
    type: NS_GET_CHAMPION_CHALLENGER_DETAILS_SUCCESS,
    payload
  };
};

export const getChampionChallengerDetailsFail = (payload) => {
  return {
    type: NS_GET_CHAMPION_CHALLENGER_DETAILS_FAIL,
    payload
  };
};
